// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qxf9m","rootMobile":"styles_rootMobile__34RTw"};